import React, { Component } from "react";
// import { connect } from 'react-redux';
// import { getConsoleUserLoginHistory } from '../../actions/userLogActions';
import { Form, Col, Row, Button, Table } from "react-bootstrap";
import { Redirect } from "react-router";
import { withRouter } from "react-router-dom";
// import Moment from 'react-moment';
// import { getConsoleUserByNameOrNumber } from '../../actions/userLogActions';
// import Pagination from '../subLevel/Pagination';

import "../../assets/styles/RetailPortalCouponsList.css";
import { get, post, sess_get, sess_post } from "../../utils/HttpRequests";
import AddNumberCSVModal from "../modals/AddNumberCSVModal";


class RetailPortalListComponent extends Component {
  constructor() {
    super();
    this.state = {
      retailPortalCoupons: [],
    };
  }

  async componentDidMount() {
    let retailPortalCoupons = await this.getRetailPortalCoupons();
    this.setState({
      ...this.state,
      retailPortalCoupons,
    });
  }

  getRetailPortalCoupons = async () => {
    const session_token = localStorage.getItem("admin-panel-sessionToken");
    return sess_get("admin/console/retail-portal", session_token)
      .then((response) => {
        return response.data.response;
      })
      .catch((error) => {

        // console.log(error);
        return [];
      });
  };

  uploadNumbers = (id) => () => {
    this.setState({ addNumberCSVModal: id });
  };

  handleModalClose = () => {
    this.setState({ addNumberCSVModal: null });
  };

  redirectToCoupon = (id) => {
    return () => {
      this.props.history.push("/retail/" + id);
    };
  };

  render() {
    return (
      <div className="retail-store-list-container">
        <div className="table-header">
          <div>Retail Store</div>
          <div>
            <button
              onClick={() => {
                this.props.history.goBack();
              }}
            >
              Back
            </button>
          </div>
          <button
            className={"add-button"}
            onClick={this.redirectToCoupon("new")}
          >
            +
          </button>
        </div>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Entity Name</th>
              <th>Retail Name</th>
              <th>City</th>
              <th>Pincode</th>
              {/* <th>percentage Cap</th> */}
              {/* <th>Usage Limit</th> */}
              {/* <th>
                <div>Used/Limit</div>
                <div>Pending</div>
              </th> */}
              <th>Branch</th>
              <th>POC Name</th>
              <th>POC Contact</th>
              <th>Used</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {this.state.retailPortalCoupons.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.entity}</td>
                  <td>{item.name}</td>
                  <td>{item.city}</td>
                  <td>{item.pincode}</td>
                  <td>{item.branch}</td>
                  <td>{item.poc_name}</td>
                  <td>{item.poc_contact}</td>
                  <td>{item.used}</td>
                  <td>{item.total}</td>
                  <td
                    className="edit"
                    onClick={this.redirectToCoupon(item._id)}
                  >
                    {" "}
                    <a className={"edit-button"}>Show coupons</a>
                  </td>
                  {/* <td className="edit" onClick={this.uploadNumbers(item._id)}>
                    {" "}
                    <a className={"edit-button"}>add Numbers</a>
                  </td> */}
                </tr>
              );
            })}
          </tbody>
        </Table>
        <AddNumberCSVModal
          id={this.state.addNumberCSVModal}
          show={this.state.addNumberCSVModal ? true : false}
          close={this.handleModalClose}
        />
      </div>
    );
  }
}

export default withRouter(RetailPortalListComponent);
